export const regions = (self) => {
    return [
        { label: self.$t('Global'), value: 1 },
        { label: self.$t('North America'), value: 2 },
        { label: self.$t('Europe'), value: 3 },
        { label: self.$t('Asia'), value: 4 }
        
    ];
}
